// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"testimonialsControlArrow-module--arrowIcon--3_sIb"};